"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Userpic = void 0;
var React = _interopRequireWildcard(require("react"));
var _utils = require("../utils");
var _ui = require("../../ui");
require("../../../src/ui/userpic/userpic.module.scss");
var _icon = require("../icon/icon");
var _excluded = ["background", "className", "initials", "size", "src", "tooltip"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n["default"] = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
// accessibility ok

var Userpic = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var background = props.background,
    className = props.className,
    initials = props.initials,
    size = props.size,
    src = props.src,
    tooltip = props.tooltip,
    attributesOriginal = _objectWithoutProperties(props, _excluded),
    attributes = attributesOriginal;
  className = (0, _utils.ClassNames)('kui-userpic', background ? 'kui-userpic--background' : null, size ? 'kui-userpic--size_' + size : null, className);
  if (background) {
    if (!attributes.style) attributes.style = {};
    attributes.style.borderColor = background;
  }
  var userpicElement = /*#__PURE__*/React.createElement("div", _extends({
    className: className,
    ref: ref
  }, attributes), src ? /*#__PURE__*/React.createElement("div", {
    className: 'kui-userpic__img',
    style: {
      backgroundImage: 'url(' + src + ')'
    }
  }) : initials ? /*#__PURE__*/React.createElement("div", {
    className: 'kui-userpic__initials'
  }, initials) : /*#__PURE__*/React.createElement(_icon.Icon, {
    className: 'kui-userpic__ico',
    size: 24,
    xlink: "user"
  }));
  if (tooltip) {
    var tooltipProps = typeof tooltip === 'string' ? {
      value: tooltip
    } : tooltip;
    return /*#__PURE__*/React.createElement(_ui.Tooltip, tooltipProps, userpicElement);
  }
  return userpicElement;
});
exports.Userpic = Userpic;
Userpic.defaultProps = {
  background: null,
  initials: null,
  size: 24,
  src: null,
  tooltip: null
};
Userpic.displayName = 'Userpic';